import { Menu } from '@mantine/core';

import classes from './Menu.module.css';

const MenuDefaults = Menu.extend({
  defaultProps: {
    radius: 'sm',
    position: 'bottom-end',
  },
  classNames: {
    dropdown: classes.dropdown,
    item: classes.item,
    itemLabel: classes.item_label,
    itemSection: classes.item_section,
    divider: classes.divider,
  },
});

const MenuItemDefaults = Menu.Item.extend({
  defaultProps: {
    color: 'gray',
  },
});

export type { MenuItemProps, MenuProps } from '@mantine/core';
export { Menu, MenuDefaults, MenuItemDefaults };
